import React from 'react';
import {
    Modal,
    ModalHeader,
    ModalBody,
} from 'reactstrap';

type FileItem = {
    file_name?: string | null;
    path: string;
};

type PreviewModalProps = {
    isOpen: boolean;
    toggle: () => void;
    file: FileItem | null;
};

const PreviewModal: React.FC<PreviewModalProps> = ({ isOpen, toggle, file }) => {
    if (!file) return null;

    const fileName =
        file.file_name?.split('/').pop() ||
        file.path?.split('/').pop() ||
        'Unknown file';

    const isImage = /\.(jpeg|jpg|png|gif|webp)$/i.test(fileName);
    const isPDF = /\.pdf$/i.test(fileName);

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            size="xl"
            centered
            style={{
                maxWidth: '90%',
                width: 'auto',
            }}
        >
            <ModalHeader toggle={toggle}>
                <span className="text-truncate" style={{ maxWidth: '80%' }}>
                    Preview:
                    <span className="text-muted ms-2">{fileName}</span>
                </span>
            </ModalHeader>

            <ModalBody className="p-0">
                <div
                    style={{
                        width: '100%',
                        height: '80vh',
                        backgroundColor: '#f8f9fa',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {isImage ? (
                        <img
                            src={file.path}
                            alt={fileName}
                            style={{
                                maxWidth: '100%',
                                maxHeight: '100%',
                                objectFit: 'contain',
                            }}
                        />
                    ) : isPDF ? (
                        <iframe
                            src={`${file.path}#toolbar=0`}
                            title={fileName}
                            width="100%"
                            height="100%"
                            style={{ border: 'none' }}
                        />
                    ) : (
                        <div className="text-center p-4 text-muted">
                            Preview not available for this file type.
                        </div>
                    )}
                </div>
            </ModalBody>
        </Modal>
    );
};

export default PreviewModal;